import { DeliveryOption } from 'libs/shared-models/src/lib/delivery-option';
import { OrderStatus } from 'libs/shared-models/src/lib/order/order-response';

export class RestaurantDashboardResponse {
  public generatedAt: string = '';
  public periodDays: number = 7;
  public currencyCode: string = 'EUR';
  public timeZone: string = '';
  public today: DashboardSummaryResponse = new DashboardSummaryResponse();
  public currentPeriod: DashboardSummaryResponse = new DashboardSummaryResponse();
  public previousPeriod: DashboardSummaryResponse = new DashboardSummaryResponse();
  public dailySeries: DashboardDailyResponse[] = [];
  public actionRequiredOrderCount: number = 0;
  public activeOrderCount: number = 0;
  public actionRequiredOrders: DashboardOrderResponse[] = [];
  public activeOrders: DashboardOrderResponse[] = [];
  public orderChannelBreakdown: DashboardOrderChannelResponse[] = [];
  public topProducts: DashboardTopProductResponse[] = [];
  public reviews: DashboardReviewsResponse = new DashboardReviewsResponse();
  public products: DashboardProductsResponse = new DashboardProductsResponse();
}

export class DashboardSummaryResponse {
  public fromDate: string = '';
  public toDate: string = '';
  public receivedOrderCount: number = 0;
  public completedOrderCount: number = 0;
  public completedOrderValueCents: number = 0;
  public averageCompletedOrderValueCents: number = 0;
  public cancelledOrderCount: number = 0;
  public refundedOrderCount: number = 0;
  public uniqueCustomerCount: number = 0;
}

export class DashboardDailyResponse {
  public date: string = '';
  public receivedOrderCount: number = 0;
  public completedOrderCount: number = 0;
  public completedOrderValueCents: number = 0;
}

export class DashboardOrderResponse {
  public id: string = '';
  public slug: string = '';
  public status: OrderStatus = OrderStatus.CREATED;
  public deliveryOption: DeliveryOption = DeliveryOption.PICKUP;
  public paymentType: string = '';
  public totalPriceCents: number = 0;
  public itemCount: number = 0;
  public createdDate: string = '';
  public estimatedDeliveryTime: string | null = null;
}

export class DashboardOrderChannelResponse {
  public deliveryOption: DeliveryOption = DeliveryOption.PICKUP;
  public orderCount: number = 0;
}

export class DashboardTopProductResponse {
  public productId: string = '';
  public productName: string = '';
  public quantitySold: number = 0;
}

export class DashboardReviewsResponse {
  public averageRating: number | null = null;
  public totalReviews: number = 0;
  public ratingDistribution: DashboardRatingDistributionResponse[] = [];
  public recentReviews: DashboardRecentReviewResponse[] = [];
}

export class DashboardRatingDistributionResponse {
  public rating: number = 0;
  public count: number = 0;
}

export class DashboardRecentReviewResponse {
  public comment: string = '';
  public createdDate: string = '';
  public id: string = '';
  public orderId: string = '';
  public orderSlug: string = '';
  public rating: number = 0;
}

export class DashboardProductsResponse {
  public total: number = 0;
  public available: number = 0;
  public unavailable: number = 0;
}
